import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {DashboardID} from '/constant/TestIDs';
import {EDGE365CHALLENGESCREEN} from '/enum/popover.enum';
import {EVENT_DATA, EVENT_NAMES, SCREEN_NAMES} from '/enum/tealium.enum';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

import {styles} from './Edge365Banner.style';

interface Props {
  onNavigate: any;
  coachId: string;
  lastPaidRank: string;
  highestRankDescription: string;
  coachCurrentRank: string;
}

export const Edge365Banner: React.FC<Props> = ({
  onNavigate,
  coachId,
  lastPaidRank,
  highestRankDescription,
  coachCurrentRank,
}) => {
  const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
    eventName: EVENT_NAMES.navigationClick,
  });
  return (
    <View style={styles.content} accessible={false}>
      <View
        accessible={true}
        accessibilityRole="header"
        accessibilityLabel="EDGE30 CHALLENGE">
        <Text allowFontScaling maxFontSizeMultiplier={2} style={styles.title}>
          EDGE30 CHALLENGE
        </Text>
      </View>
      <View
        accessible={true}
        accessibilityRole="header"
        accessibilityLabel="Engage Duplicate Grow Elevate">
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.subTitle}>
          Engage Duplicate Grow Elevate
        </Text>
      </View>
      <View
        accessible={true}
        accessibilityLabel="A 30-day challenge to build bold, consistent daily actions for massive momentum in your business and leadership.">
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.subtitle}>
          A 30-day challenge to build bold, consistent daily actions for massive
          momentum in your business and leadership.
        </Text>
      </View>
      <TouchableOpacity
        style={styles.button}
        accessibilityRole="button"
        accessibilityLabel="Track EDGE30 Now"
        onPress={() => {
          onNavigate('card', {
            modalName: EDGE365CHALLENGESCREEN,
            coachId,
          });
          sendEvent({
            buttonName: EVENT_DATA.buttonName,
            buttonType: EVENT_DATA.buttonType,
            screenName: SCREEN_NAMES.dashboard,
            lastPaidRank: lastPaidRank,
            coach_highest_rank: highestRankDescription,
            coach_current_rank: coachCurrentRank,
            coach_id: coachId.toString(),
          });
        }}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          accessible={true}
          accessibilityRole="button"
          accessibilityLabel="Track EDGE30 Now"
          accessibilityHint="Navigates to the EDGE30 Challenge screen"
          style={styles.buttonText}
          isBold
          testID={DashboardID.dashboardEdgeBannerTrackNowButton}>
          Track EDGE30 Now
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default Edge365Banner;
